const colorNameMap = new Map([
  ['Público', '#55A546'],
  ['Privado', '#FFB02E']
]);

export function resolveColor(name: string) {
  return colorNameMap.get(name) || '#D4282A';
}
